import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '../../../../componentsv2/Typography';
import Button from '../../../../componentsv2/Button';
import { useTranslation } from '../../../../hooks/i18n';
import { COLORS } from '../../../../themev2';

interface Step2AlternativeMethodsProps {
  onBack: () => void;
  onSelectRecovery: () => void;
  onSelectGetHelpFromMarco: () => void;
}

const Step2AlternativeMethods = ({
  onBack,
  onSelectRecovery,
  onSelectGetHelpFromMarco,
}: Step2AlternativeMethodsProps) => {
  const { t } = useTranslation();

  return (
    <Grid container rowSpacing={2}>
      <Grid item xs={12}>
        <Typography variant="h5" sx={{ fontWeight: 600, textAlign: 'center' }}>
          {t('common:twoFactor.alternativeMethods')}
        </Typography>
      </Grid>
      <Grid item xs={12} sx={{ marginBottom: '2em' }}>
        <Typography
          variant="body1"
          sx={{
            textAlign: 'center',
            color: COLORS.gray[1100],
            size: '18px',
            fontWeight: 400,
          }}
        >
          {t('common:twoFactor.tryAlternative')}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Button fullWidth type="link" color="secondary" onClick={onSelectRecovery}>
          {t('common:twoFactor.useRecoveryCode')}
        </Button>
      </Grid>
      <Grid item xs={12}>
        <Button fullWidth type="link" color="secondary" onClick={onSelectGetHelpFromMarco}>
          {t('common:twoFactor.getHelpFromMarco')}
        </Button>
      </Grid>
      <Grid item xs={12}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            width: { xs: '100%', md: '50%', lg: '40%' },
            margin: '2em auto',
          }}
        >
          <Button fullWidth type="outline" color="tertiary" onClick={onBack}>
            {t('common:back')}
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Step2AlternativeMethods;
